import React from "react";
import { useLocation } from "react-router-dom";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_M4_NaiveStringMatching = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <DAAModuleSubtopic
      title="Naive String-matching Algorithms"
      videos={["https://www.youtube.com/embed/nK7SLhXcqRo"]}
      takeaways={[
        { text: "Drawbacks of the naive string matching algorithm." },
        { text: "Comparison between the naive string-matching algorithm and the KMP string-matching algorithm." },
        { text: "Drawbacks of the naive string-matching algorithm that are overcome by the KMP algorithm." },
        { text: "Time complexity and space complexity." },
      ]}
      questions={[]}
      exampleVideos={[]}
      subtopics={subtopics}
      subjectPath={subjectPath}
    />
  );
};

export default DAA_M4_NaiveStringMatching;
